<script setup>
import '@/assets/cloudCounter/css/style.css'
import { ref, computed, onMounted } from 'vue';
import { getCompleteReserveApply } from '@/apis/system';
import { getCecPdfRecordToken } from '@/apis/record.js';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import Loading from '@/components/Loading.vue';
import routeName from '@/router/constant';
import aplCatlCode from '@/json/aplCatlCode';
import { useStore } from 'vuex';


const data = ref(null);
const isLoading = ref(false);
const todayRoc = computed(() => {
    const dateStr = new Date().toJSON().slice(0, 10).split('-');
    const year = `${parseInt(dateStr[0]) - 1911}`;
    return `${year}/${dateStr[1]}/${dateStr[2]}`;
});
const store = useStore();
const aplCatl = computed(() => store.state.services.aplCatl);

const download = (regiNo) => {
    isLoading.value = true;
    getCecPdfRecordToken(regiNo).then((response) => {
        const token = response.data.token;
        const path = process.env.VUE_APP_CONTEXT_PATH;
        const baseUrl = `${window.location.origin}${path}`;
        console.log(baseUrl + '/api/transaction/record/downloadCECPdf?token=' + token, '_blank');
        window.open(baseUrl + '/api/transaction/record/downloadCECPdf?token=' + token, '_blank');
    }).finally(() => {
        setTimeout(() => {
            isLoading.value = false;
        }, 500);
    });
};

const getData = () => {
    let isApiBack = false;
    isLoading.value = true;
    getCompleteReserveApply().then(res => {
        data.value = res.data;
        // store.dispatch('permissions/resetTransactionId');
        // if (data.value.insuredName) {
        //     EUDC();
        // }
    }).catch(() => {
        console.log('送出失敗');
    }).finally(() => {
        isApiBack = true;
        isLoading.value = false;
    });

    // 因為借款的api需要時間較長 增加loading
    // setTimeout(() => {
    //    if (!isApiBack && store.state.services.aplCatl === aplCatlCode.PON4300) {
    // setLoading(true, '資料載入中...');
    //        isLoading2.value = true;
    //    }
    // }, 500);
};

/**
 * Hook
 */
onMounted(() => {
    getData();
});
</script>

<template>

    <Layout class="bg-white"
        :header="{ text: '', backBtn: { visible: false }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <Loading :is-loading="isLoading" />
        <div class="pt-2 pb-10">
            <div class="pb-4 text-center">
                <div class="inline-block">
                    <svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_755_21211)">
                            <rect x="21.3271" y="52.1768" width="56.6171" height="10"
                                transform="rotate(-45 21.3271 52.1768)" fill="#70E1F2" />
                            <rect width="30" height="10"
                                transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 35.4688 52.1768)"
                                fill="#70F2D0" />
                            <rect width="10" height="10"
                                transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 35.4688 52.1768)"
                                fill="#11699C" />
                        </g>
                        <defs>
                            <clipPath id="clip0_755_21211">
                                <rect width="72" height="72" fill="white" transform="translate(0.5)" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <h2 class="font-bold text-2xl">預約申請完成</h2>
            </div>
            <div class="text-sm">
                <!-- <p class="pb-2">
                    提醒您，預計將於 10 分鐘內以簡訊發送視訊連結通知您與被保險人{{ data?.insuredName }}，請於預約時間點選連結進行視訊
                </p> -->
                <p class="pb-2">{{ data?.remindMsg }}</p>
            </div>
        </div>

        <div class="pb-6">
            <div class="flex items-end pb-4">
                <h3 class="flex-1 font-bold text-xl">申請紀錄</h3>
                <button class="pt-3 text-sm text-[#0093C1]" @click="download(data?.regiNo)">
                    <svg class="inline-block" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.66699 8V11.3333C2.66699 12.0697 3.26395 12.6667 4.00033 12.6667H7.01088H12.0003C12.7367 12.6667 13.3337 12.0697 13.3337 11.3333V8"
                            stroke="#0093C1" stroke-width="1.3" stroke-linecap="round" />
                        <path d="M5.33301 6.66667L7.99967 9.58203M7.99967 9.58203L10.6663 6.66667M7.99967 9.58203V2"
                            stroke="#0093C1" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    下載
                </button>
            </div>

            <CaseBox :hasShadow="false" :caseBox="{
                boxList: [
                    {
                        flexClass: 'justify-between',
                        list: [
                            { key: '申請項目', value: data?.aplCatlText },
                            { key: '申請日期', value: todayRoc },
                            ...(aplCatl === aplCatlCode.LOAN ? [] : [{ key: '保單號碼', value: data?.fullPolicyNo }]),
                            { key: '受理案號', value: data?.regiNo }
                        ]
                    }
                ]
            }" />

            <div class="flex items-end pb-4">
                <h3 class="flex-1 font-bold text-xl">視訊預約時段</h3>
            </div>

            <CaseBox :hasShadow="false" :caseBox="{
                boxList: [
                    {
                        flexClass: 'justify-between',
                        list: [
                            { key: '日期', value: data?.datePeriod },
                            { key: '時間', value: data?.timePeriod },
                        ]
                    }
                ]
            }" />
        </div>

        <ul v-if="aplCatl === aplCatlCode.LOAN" class="list-disc pl-6 text-sm">
            <li class="pb-2">本次受理案號申請內容為加密之PDF檔，密碼為您登入時之要保人身分證字號(大小寫視為不同字母)。</li>
            <li class="pb-2">若欲查詢保單借款處理進度或取消本次預約申請，請點選【查看申請進度】查詢。</li>
            <li class="pb-2">若您對於本次借款申請有任何疑問，請撥打本公司客戶服務專線 0809-026-688 洽詢。</li>
        </ul>    
        <ul v-else class="list-decimal pl-6 text-sm">
            <li class="pb-2">本次受理案號申請內容為加密之PDF檔，密碼為您登入時之要保人身分證字號(大小寫視為不同字母)。</li>
            <li class="pb-2">若欲查詢保單變更處理進度或取消本次預約申請，請點選【查詢/取消預約資料】查詢。</li>
            <li class="pb-2">若您對於本次變更申請有任何疑問,請撥打本公司客戶服務專線 0809-000-550 洽詢。</li>
        </ul>

        <template v-slot:bottom>
            <div class="footer-shadow">
                <div class="flex w-full px-2 py-3 max-w-[768px] mx-auto">
                    <div class="flex-1 px-2">
                        <RouterLink class="block py-3 text-center rounded bg-[#CCF3FF] text-[#0093C1]"
                            :to="{ name: routeName.CLOUD_E_COUNTER_HOME, params: { tab: 1 } }">
                            查看申請進度
                        </RouterLink>
                    </div>
                    <div class="flex-1 px-2">
                        <RouterLink class="block py-3 text-center rounded bg-[#0093C1] text-white"
                            :to="{ name: routeName.CLOUD_E_COUNTER_HOME }">
                            回首頁
                        </RouterLink>
                    </div>
                </div>
            </div>
        </template>

    </Layout>

</template>

<style scoped>
.footer-shadow {
    box-shadow: 0px -4px 12px 0px #0C0E1F0A;
}
</style>
